module.exports = __webpack_public_path__ + "img/count_down_block.58823d82.png";